import styled, { css } from 'styled-components';

export type ControlPillVariant = 'primary' | 'secondary';

const variantStyles = {
  primary: css`
    background: ${({ theme }) => theme.modelVisualizer.controlPill.primaryBackground};
  `,
  secondary: css`
    background: ${({ theme }) => theme.modelVisualizer.controlPill.secondaryBackground};
  `,
};

export const ControlPill = styled.div<{ variant?: ControlPillVariant }>`
  display: flex;
  align-items: center;
  gap: 10px;
  min-height: 26px;
  padding: 2px 8px;
  border-radius: 100px;
  box-shadow: ${({ theme }) => theme.modelVisualizer.controlPill.boxShadow};
  ${({ variant = 'primary' }) => variantStyles[variant]}
`;
